import React, { useId, useState } from "react";
import { Box, Typography } from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { T } from "utils/backrrTokens";
import InfoHint from "./InfoHint";

// Context, not control: the breakdowns and the campaign table answer questions
// an admin asks occasionally, so they sit behind a heading that states what is
// inside rather than taking permanent room above it.
//
// The summary line carries the count, so collapsed is still informative — a
// disclosure that hides the only clue about its contents just costs a click.
const Disclosure = ({ title, summary, hint, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    // The hint sits OUTSIDE the disclosure button: nesting a button inside a
    // button is invalid HTML, and the inner one would swallow the toggle click.
    <Box>
      <Box display="flex" alignItems="center">
      <Box
        component="button"
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          background: "none",
          border: 0,
          padding: 0,
          cursor: "pointer",
          font: "inherit",
          textAlign: "left",
          "&:focus-visible": { outline: `2px solid ${T.accent}`, outlineOffset: "3px", borderRadius: "4px" },
        }}
      >
        <KeyboardArrowDownRounded
          sx={{
            fontSize: "1.1rem",
            color: T.inkMuted,
            transform: open ? "none" : "rotate(-90deg)",
            transition: "transform 140ms ease",
          }}
        />
        <Typography component="span" sx={{ fontSize: "0.875rem", fontWeight: 600, color: T.ink }}>
          {title}
        </Typography>
        {summary && (
          <Typography component="span" sx={{ fontSize: "0.75rem", color: T.inkSubtle }}>
            {summary}
          </Typography>
        )}
      </Box>
        {hint && <InfoHint text={hint} label={title} />}
      </Box>

      {open && (
        <Box id={panelId} sx={{ marginTop: 1.75 }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default Disclosure;
